import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const STATS = [
  { value: '15.000+', label: 'Mutlu Müşteri', icon: 'ri-user-smile-line' },
  { value: '320+', label: 'Farklı Tur Güzergahı', icon: 'ri-map-2-line' },
  { value: '12', label: 'Yıllık Deneyim', icon: 'ri-calendar-check-line' },
  { value: '98%', label: 'Müşteri Memnuniyeti', icon: 'ri-star-line' },
];

export default function HakkimizdaPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    '@id': `${siteUrl}/hakkimizda`,
    url: `${siteUrl}/hakkimizda`,
    name: 'Hakkımızda | Ankara Travelers',
    description: 'Ankara Travelers, 2013 yılından bu yana Ankara çıkışlı tur paketleri düzenleyen TÜRSAB üyesi güvenilir bir seyahat acentasıdır.',
    inLanguage: 'tr-TR',
    publisher: {
      '@type': 'TravelAgency',
      name: 'Ankara Travelers',
      foundingDate: '2013',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Ankara',
        addressCountry: 'TR',
      },
      telephone: '+905400015806',
      email: 'info@ankaratravelers.com',
    },
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <title>Hakkımızda | Ankara Travelers Turizm - 12 Yıllık Deneyim</title>
      <meta name="description" content="Ankara Travelers hakkında bilgi edinin. 2013'ten bu yana Ankara çıkışlı tur düzenleyen TÜRSAB üyesi seyahat acentası. 15.000+ mutlu müşteri, 320+ güzergah, yurt dışı tur ve tatil paketleri." />
      <meta name="keywords" content="Ankara Travelers hakkında, Ankara seyahat acentası, TÜRSAB üyesi tur firması" />
      <link rel="canonical" href={`${siteUrl}/hakkimizda`} />
      <meta property="og:title" content="Hakkımızda | Ankara Travelers" />
      <meta property="og:description" content="2013'ten bu yana Ankara'dan dünyaya açılan kapınız. 15.000+ mutlu müşteri, TÜRSAB üyesi güvenilir seyahat acentası." />
      <meta property="og:url" content={`${siteUrl}/hakkimizda`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/ec6cb45173117b45183a1f559ec4b6ca.jpg"
            alt="Ankara Travelers Hakkında"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60" />
        </div>
        <div className="relative max-w-4xl mx-auto px-6 py-28 text-center">
          <span className="inline-block bg-orange-500/90 text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wider uppercase">
            Bizi Tanıyın
          </span>
          <h1 className="text-5xl font-bold text-white mb-5 leading-tight">Ankara Travelers Hakkında</h1>
          <p className="text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            2013'ten bu yana Ankara'dan dünyaya açılan kapınız olarak, hayalinizdeki tatili gerçeğe dönüştürmek için buradayız.
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-orange-500 py-10">
        <div className="max-w-5xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map(s => (
            <div key={s.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                <i className={`${s.icon} text-2xl text-white/80`} />
              </div>
              <div className="text-3xl font-bold text-white mb-1">{s.value}</div>
              <div className="text-orange-100 text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Hikayemiz */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest">Hikayemiz</span>
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mt-2 mb-6">
                Küçük Bir Hayalden Büyük Bir Aileye
              </h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-4">
                Ankara Travelers, 2013 yılında "Ankara'dan daha iyi turlar organize edilebilir" hayaliyle küçük bir ofiste kuruldu. O günden bu yana 15.000'den fazla misafirimize unutulmaz anlar yaşattık.
              </p>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed mb-4">
                Günübirlik Ankara turlarından başladığımız yolculuk, bugün Avrupa, Orta Doğu ve Uzak Doğu'ya uzanan geniş bir tur portföyüne dönüştü. Her tur, uzman rehberlerimiz ve titiz planlamalarımızla hayata geçirilir.
              </p>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                Türkiye Seyahat Acentaları Birliği (TÜRSAB) üyesi olarak, tüm turlarımızda yasal güvence, kalite standartları ve şeffaf fiyatlandırma ilkesini benimsiyoruz.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20modern%20travel%20agency%20office%20interior%20Ankara%20Turkey%20maps%20on%20walls%20team%20working%20warm%20lighting%20professional%20tourism%20office%20wooden%20furniture%20plants&width=700&height=500&seq=about-office&orientation=landscape"
                alt="Ankara Travelers Ofisi"
                className="w-full h-80 object-cover object-top rounded-2xl"
              />
              <div className="absolute -bottom-5 -left-5 bg-orange-500 text-white rounded-xl px-6 py-4">
                <div className="text-2xl font-bold">2013</div>
                <div className="text-orange-100 text-xs">Kuruluş Yılı</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Misyon & Vizyon */}
      <section className="py-16 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white dark:bg-gray-900 rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 dark:bg-orange-900/30 rounded-xl mb-5">
                <i className="ri-target-line text-2xl text-orange-500" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Misyonumuz</h3>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                Her bütçeye ve zevke uygun, güvenli, kaliteli ve unutulmaz seyahat deneyimleri sunmak; Ankara'yı Türkiye'nin seyahat merkezi haline getirmek.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-900 rounded-2xl p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 dark:bg-orange-900/30 rounded-xl mb-5">
                <i className="ri-eye-line text-2xl text-orange-500" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">Vizyonumuz</h3>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                Türkiye'nin en güvenilir seyahat markası olmak; teknolojiyi, kişiselleştirilmiş hizmeti ve sürdürülebilir turizm anlayışını bir araya getirerek sektörde öncü olmak.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Değerlerimiz */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-14">
            <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest">Değerlerimiz</span>
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mt-2">Her Turda Bizi Biz Yapan İlkeler</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: 'ri-shield-star-line', title: 'Güvenilirlik', desc: 'TÜRSAB üyesi, şeffaf fiyatlandırma ve net iptal koşullarıyla her adımda yanınızdayız.' },
              { icon: 'ri-heart-line', title: 'Müşteri Odaklılık', desc: 'Her müşterimizin ihtiyacına özel çözümler üretiyor, beklentilerin ötesine geçmeyi hedefliyoruz.' },
              { icon: 'ri-leaf-line', title: 'Sürdürülebilirlik', desc: 'Doğayı ve kültürel mirası koruyan, çevreye duyarlı turizm anlayışını benimsiyoruz.' },
              { icon: 'ri-medal-line', title: 'Kalite', desc: 'Araçlardan konaklama seçimlerine kadar her detayda en yüksek standartları uyguluyoruz.' },
              { icon: 'ri-team-line', title: 'Deneyim', desc: '12 yıllık sektör tecrübemiz ve 15.000+ mutlu müşteriyle biriktirdiğimiz bilgi birikimiyiz.' },
              { icon: 'ri-compass-3-line', title: 'Keşif Ruhu', desc: 'Sıradan rotaların ötesine geçen, özgün ve unutulmaz deneyimler tasarlamayı seviyoruz.' },
            ].map(v => (
              <div key={v.title} className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 transition-colors duration-300">
                <div className="w-11 h-11 flex items-center justify-center bg-orange-100 dark:bg-orange-900/30 rounded-xl mb-4">
                  <i className={`${v.icon} text-xl text-orange-500`} />
                </div>
                <h4 className="font-bold text-gray-900 dark:text-white mb-2">{v.title}</h4>
                <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-orange-500">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Birlikte Yeni Bir Maceraya Hazır Mısınız?</h2>
          <p className="text-orange-100 mb-8">Hayalinizdeki turu hemen keşfedin, uzman ekibimizle planlamaya başlayın.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/ara"
              className="px-8 py-3 bg-white text-orange-600 font-semibold rounded-full hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Tur Ara
            </Link>
            <Link
              to="/gunubirlik-turlar"
              className="px-8 py-3 border-2 border-white text-white font-semibold rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              Günübirlik Turlar
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
